import { render } from "./AdminLoginPage.vue?vue&type=template&id=b0cad948&scoped=true"
import script from "./AdminLoginPage.vue?vue&type=script&lang=js"
export * from "./AdminLoginPage.vue?vue&type=script&lang=js"

import "./AdminLoginPage.vue?vue&type=style&index=0&id=b0cad948&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0cad948"]])

export default __exports__